/**
 * 素材服务模块：处理用户爬取的商品素材数据
 */

import { apiService } from './api'
import type {
  Material,
  MaterialListParams,
  MaterialListResponse,
  ApiResponse,
} from '@/types/material'

const MATERIAL_ENDPOINT = '/api/user/crawled-goods' as const

/**
 * 获取素材列表
 * @param params 查询参数
 * @returns 素材列表
 */
export async function listMaterials(
  params?: MaterialListParams
): Promise<MaterialListResponse> {
  const queryParams: Record<string, string> = {}

  if (params !== undefined) {
    if (params.current !== undefined) {
      queryParams['current'] = String(params.current)
    }
    if (params.pageSize !== undefined) {
      queryParams['pageSize'] = String(params.pageSize)
    }

    const titleKeyword = params.title ?? params.keyword
    if (titleKeyword !== undefined && titleKeyword !== '') {
      queryParams['title'] = titleKeyword
    }

    if (params.remark !== undefined && params.remark !== '') {
      queryParams['remark'] = params.remark
    }
    if (params.platform !== undefined) {
      queryParams['platform'] = params.platform
    }
  }

  const response = await apiService.get<ApiResponse<MaterialListResponse>>(
    MATERIAL_ENDPOINT,
    queryParams
  )
  return response.data
}

/**
 * 获取素材详情
 * @param id 素材 ID
 * @returns 素材详情
 */
export async function getMaterial(id: string): Promise<Material> {
  const response = await apiService.get<ApiResponse<Material>>(
    `${MATERIAL_ENDPOINT}/${id}`
  )
  return response.data
}

/**
 * 删除单个素材
 * @param id 素材 ID
 * @returns 删除结果
 */
export async function deleteMaterial(
  id: string
): Promise<{ message: string }> {
  const response = await apiService.delete<
    ApiResponse<{ message: string }>
  >(`${MATERIAL_ENDPOINT}/${id}`)
  return response.data
}

/**
 * 删除所有素材
 * @returns 删除结果
 */
export async function deleteAllMaterials(): Promise<{ message: string }> {
  const response = await apiService.delete<
    ApiResponse<{ message: string }>
  >(MATERIAL_ENDPOINT)
  return response.data
}

/**
 * 按批次 ID 获取素材列表
 * @param batchId 批次 ID
 * @param params 查询参数
 * @returns 素材列表
 */
export async function listMaterialsByBatch(
  batchId: string,
  params?: MaterialListParams
): Promise<MaterialListResponse> {
  const queryParams: Record<string, string> = {
    batchId,
  }

  if (params !== undefined) {
    if (params.current !== undefined) {
      queryParams['current'] = String(params.current)
    }
    if (params.pageSize !== undefined) {
      queryParams['pageSize'] = String(params.pageSize)
    }

    const titleKeyword = params.title ?? params.keyword
    if (titleKeyword !== undefined && titleKeyword !== '') {
      queryParams['title'] = titleKeyword
    }
  }

  const response = await apiService.get<ApiResponse<MaterialListResponse>>(
    MATERIAL_ENDPOINT,
    queryParams
  )
  return response.data
}
